
const activeColor = '#4FC098';
const accentColor = activeColor;

const defaultTheme = {
	textColor: '#297FCA',
	disabledTextColor: '#575757',
	scrollThumbColor: '#4FC098', //'#A6A6A6',
	pageSeparatorColor: '#C6DAE7',
	activeColor,
	tableRowHoverBackground: 'rgba(209, 241, 230, 0.4)',
	tableRowSelectedBackground: 'rgba(209, 241, 230, 0.8)',
	tableRowSelectedOutline: '2px solid rgba(179, 241, 200, 1)',
	tableRowBackground: '#FFFFFF',
	tableRowAltBackground: '#F3FAFD',
	tableHeaderBackground: '#FFFFFF',
	tableHeaderShadow: '7px 13px 80px rgba(21, 46, 67, 0.1)',
	tableHeaderTextColor: '#575757',
	tableCellTextColor: '#575757',
	tableCellBorderColor: '#E8EFF1',
	bcgOk: '#D8FFDC',
	bcgWarning: '#FFDCC9',
	bcgError: '#DC000011',
	errorBorderColor: '#DC000022',
	okColor: '#00A811',
	warningColor: '#FF6A1A',
	errorColor: '#DC0000',

	pageContentPadding: `
		padding: 21px 121px;
		@media (max-width: 1600px) {
			padding: 21px 49px;
		}
		@media (max-width: 1500px) {
			padding: 21px 39px;
		}
		@media (max-width: 1400px) {
			padding: 21px 29px;
		}
	`,

	recordingTypeAColor: '#306DA0',
	bcgRecordingTypeA: '#D1F1E6',
	recordingTypeVColor: '#5C2775',
	bcgRecordingTypeV: '#F6E3FF',
	recordingTypeOtherColor: '#FF6A1A',
	bcgRecordingTypeOther: '#FFDCC9',

	// ps-gui modal style
	modalOverlayBackground: 'rgba(235,246,252, 0.7)',
	//pendingRequestSpinnerSize: '24px',
	pendingRequestMessageColor: '#575757',
	pendingRequestMessageFontSize: '24px',
	pendingRequestMessageFontWeight: '500',

	dialogHeaderFontWeight: '300',
	dialogHeaderFontSize: '24px',
	dialogPadding: '24px',
	dialogBorderRadius: '15px',
	dialogBorder: '1px solid #ffffff',
	dialogShadow: '0px 0px 6px rgba(0, 0, 0, 0.25)',
	dialogBackground: '#ffffff',

	// ps-gui input style

	fullButtonBorder: '2px solid #4FC098',
	fullButtonFontSize: '16px',
	fullButtonFontWeight: '500',
	fullButtonBackground: '#4FC098',
	fullNegativeButtonBackground: '#DC0000',
	fullNegativeButtonBorder: '2px solid #DC0000',
	fullButtonColor: '#ffffff',
	fullButtonCursor: 'pointer',
	fullButtonPadding: '8px 24px',
	fullButtonMargin: '4px',
	fullButtonBorderRadius: '15px',
	//	fullButtonHoverTextDecoration: 'underline',
	fullButtonHoverBorder: '2px solid #4AB690',
	fullButtonHoverBackground: '#4AB690',
	fullNegativeButtonHoverBorder: '2px solid #D20000',
	fullNegativeButtonHoverBackground: '#D20000',

	mediumButtonBorder: '1px solid #4FC098',
	mediumButtonColor: '#4FC098',
	mediumButtonBackground: 'none',
	mediumButtonHoverBorder: '1px solid #4AB690',
	mediumButtonHoverColor: '#4AB690',
	mediumButtonHoverBackground: 'none',
	mediumButtonBorderRadius: '15px',
	mediumButtonHoverTextDecoration: 'underline',
	mediumButtonShadow: '-4px 2px 33px 3px rgba(21, 46, 67, 0.1)',
	mediumNegativeButtonBackground: 'none',
	mediumNegativeButtonBorder: '1px solid #DC0000',
	mediumNegativeButtonHoverBorder: '1px solid #D20000',
	mediumNegativeButtonHoverBackground: 'none',
	mediumNegativeButtonColor: '#DC0000',
	mediumNegativeButtonHoverColor: '#DC0000',

	lightButtonBorder: 'none',
	lightButtonColor: '#297FCA',
	lightNegativeButtonColor: '#DC0000',
	lightButtonBackground: 'none',
	lightNegativeButtonBackground: 'none',
	lightNegativeButtonBorder: 'none',
	lightButtonPadding: '8px 0px',
	lightButtonHoverColor: '#297FCA',
	lightNegativeButtonHoverColor: '#DC0000',
	lightButtonHoverTextDecoration: 'underline',
	lightButtonHoverBackground: 'none',
	lightButtonHoverBorder: 'none',
	lightNegativeButtonHoverBackground: 'none',
	lightNegativeButtonHoverBorder: 'none',


	tabularInputHeaderBackground: '#E3F0F5',
	tabularInputHeaderColor: '#575757',
	tabularInputHeaderFontWeight: '500',
	tabularInputHeaderCellPadding: '8px 4px',
	tabularInputHeaderCellBorder: '1px solid #dadfe7',
	tabularInputInputPadding: '8px 12px',
	tabularInputCellBorder: '1px solid #eaeff7',
	tabularInputCellBackground: '#ffffff',
	tabularInputRowHoverBackground: 'rgba(209, 241, 230, 0.4)',

	formItemLabelFontSize: '14px',
	formItemLabelFontWeight: '500',
	formItemLabelColor: '#575757',
	formItemLabelPadding: '5px 0px',
	formItemMargin: '2px 4px',
	inputPadding: '8px 12px',
	inputBorderRadius: '15px',
	inputBorder: '1px solid #C6DAE7',
	inputErrorBorderColor: '#DC000077',
	inputColor: '#297FCA',
	inputFontSize: '16px',
	inputFontWeight: '400',
	inputOutline: 'none',
	inputPlaceholderColor: '#297FCAB3',
	inputBackground: '#fff',
	inputSelectionBackground: '#297FCA',
	inputSelectionColor: 'rgb(251,251,251)',
	popupInputPopupPadding: '16px',
	popupInputButtonToolbarMargin: '16px 0px 0px 0px',
	rangeHyphenColor: '#4FC098',
	rangeHyphenFontSize: '30px',
	inputReadOnlyBackground: '#abcaca22',
	inputReadOnlyColor: '#575757',

	lookupPopupBackground: '#FFFFFF',
	lookupPopupBorderRadius: '15px',
	lookupPopupBorder: '1px solid #C6DAE7',
	lookupPopupCellPadding: '8px 12px',
	lookupPopupNoDeleteLeftPadding: '12px',

	lookupPopupFontWeight: '400',
	lookupPopupFontSize: '16px',
	lookupPopupPadding: '4px 0px',
	lookupPopupSelectedRowBackground: '#FFFFFF',
	lookupPopupSelectedRowFontWeight: '700',
	lookupPopupHoverRowFontWeight: '700',
	lookupPopupHoverRowBackground: '#FFFFFF',
	lookupPopupSelectedRowCellTextBottomBorder: '2px solid #4FC098',
	lookupInputIconColor: '#4FC098',
	lookupInputClearIconMarginRight: '4px',

	inputLeftIconRightMargin: '4px',

	//lookupPopupHoverRowTextDecoration: 'underline',

	enumPagerPadding: '0px',
	enumPagerIconPadding: '4px 4px',
	enumPagePadding: '5px 8px',
	enumPageColor: '#297FCA',
	enumPageFontSize: '14px',
	enumPageFontWeight: '500',
	enumPageBorder: '1px solid #C6DAE7',
	enumPageBorderRadius: '7px',
	enumPageMargin: '8px',

	enumPagerPrevButtonTextMargin: '0px 0px 0px 4px',
	enumPagerNextButtonTextMargin: '0px 4px 0px 0px',

	//enumHoverPageColor: '#000000',
	enumHoverPageTextDecoration: 'underline',
	enumSelectedPageBorder: '2px solid ' + activeColor,
	enumSelectedPageFontWeight: '900',

	//tabStripHorizontalBottomBorder: '1px solid #C6DAE7',
	tabHorizontalBottomLineColor: '#C6DAE7',
	tabHorizontalBackground: 'rgb(251,251,251)',
	tabHorizontalFontWeight: '400',
	tabHorizontalColor: '#306DA0',
	tabHorizontalFontSize: '16px',
	tabHorizontalPadding: '10px 20px',
	tabHorizontalMargin: '0px 10px 0px 0px',
	tabHorizontalBorderRadius: '15px 15px 0px 0px',

	tabHorizontalSelectedColor: '#306DA0',
	tabHorizontalSelectedBackground: 'rgb(251,251,251)',
	tabHorizontalSelectedFontWeight: '500',
	tabHorizontalHoverTextDecoration: 'underline',
	tabHorizontalSelectedBorder: '1px solid #dadfe7',
	tabHorizontalSelectedBorderBottom: 'none',

	//boxHeaderBottomBorder: '1px solid #dadfe7',
	//	boxHeaderColor: altTextColor,
	//boxHeaderBackground: 'rgba(0,0,0,0.04)',
	boxHeaderBackground: 'white',
	boxHeaderFontWeight: '700',
	boxHeaderFontSize: '16px',
	boxHeaderPadding: '12px',
	boxHeaderMargin: '0px',
	// boxBorder: '1px solid #dadfe7',
	// boxBorderRadius: '11px',
	boxBackground: 'white',


	moduleHeaderMargin: '4px 4px',
	moduleHeaderPadding: '0px 4px',
	moduleHeaderItemFontSize: '18px',
	moduleHeaderItemFontWeight: '700',
	moduleHeaderItemMargin: '0px 8px 0px 0px',
	moduleHeaderItemColor: '#3A3A3A',
	moduleHeaderLightItemColor: '#3A3A3A' + '77',


	checkBoxPaneMargin: '8px auto',
	checkBoxPanePadding: '4px',

	checkBoxMargin: '0px 8px',
	checkBoxPadding: '2px 4px',
	checkBoxIconMarginRight: '4px',
	checkBoxIconSize: '16px',

	checkBoxCheckedIconColor: accentColor,
	checkBoxCheckedIconSize: '18px',
	checkBoxCheckedTextColor: accentColor,
	checkBoxCheckedTextFontSize: '16px',
	checkBoxCheckedTextFontWeight: '800',

	checkBoxLargeIconMarginRight: '8px',
	checkBoxLargeTextFontWeight: '700',
	checkBoxLargeCheckedTextFontWeight: '700',
	checkBoxLargeCheckedBorder: '2px solid #0D9452',
	checkBoxLargeBorder: '2px solid #0D9452',
	checkBoxLargeBorderRadius: '4px',
	checkBoxLargePadding: '6px',
	checkBoxLargeMargin: '8px',
	checkBoxLargeIconMarginRight: '4px',
	checkBoxLargeIconSize: '16px',
	checkBoxLargeCheckedIconSize: '16px',
	checkBoxLargeIconColor: '#0D9452',
	checkBoxLargeTextColor: '#0D9452',
	//checkBoxLargeCheckedIconColor: '#000',
	checkBoxLargeCheckedTextColor: '#fff',
	checkBoxLargeCheckedIconColor: '#fff',
	//	checkBoxLargeBackground: '#eaeff7',
	checkBoxLargeCheckedBackground: '#0D9452',
	checkBoxPaneLargeLabelFontWeight: '700',
	checkBoxPaneLargeLabelFontSize: '16px',
	checkBoxPaneLargeLabelMargin: '8px 0px 0px 16px',

};

export function getTheme(type, options) {
	return defaultTheme;
}
